import React from 'react';
import { CalendarIcon } from 'components/common/icons';
import { Col, DatePicker, FilterDrawer, Form, FormInstance, Row, Select } from 'components';
import { useFilters } from './useFilters';
import { MicroserviceTypes } from 'typings';

interface IAttachmentsFilter {
  form: FormInstance;
  service?: MicroserviceTypes;
  drawerOpen: boolean;
  entityName: string;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const AttachmentsFilterDrawer = React.memo((props: IAttachmentsFilter) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters, entityName, service } = props;
  const { clearFilters, attachmentType } = useFilters({ form, resetFilters, entityName, service });
  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form layout="vertical" form={form} onFinish={applyFilters}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item label={'Attachment Type'} name={'attachmentTypes'}>
              <Select mode={'multiple'} maxTagCount={'responsive'} allowClear={true} options={attachmentType} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={'Created Date'} name={'createdDate'}>
              <DatePicker.RangePicker size={'middle'} style={{ width: '100%' }} suffixIcon={<CalendarIcon />} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={'Updated Date'} name={'updatedDate'}>
              <DatePicker.RangePicker size={'middle'} style={{ width: '100%' }} suffixIcon={<CalendarIcon />} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
